import styled from 'styled-components';

export const Wrapper = styled.nav`
  font-family: 'Open Sans', sans-serif;
  padding: 30px 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  position: relative;
  @media(max-width: 768px) {
    padding: 20px;
    display: block;
    text-align: center;
  }
  @media(max-width: 425px) {
    padding: 20px 10px;
  }

  img {
    @media(max-width: 425px) {
      margin-bottom: 20px;
    }
  }
  .container {
    max-width: 1600px;
    margin: 0 auto;
    width: 100%;
    padding: 0px 30px;
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    li {
      padding: 0 25px;
      font-size: 15px;
      @media(max-width: 768px) {
        padding: 0 10px;
      }
      @media(max-width: 425px) {
        padding: 0 7px;
      }
      a {
        font-weight: 600;
        color: #fff;
        &:hover {
          text-decoration: underline;
        }
        &.login-link {
          color: #9A9A9A;
        }
      }
    }
  }
`;
